/*!

=========================================================
* Paper Dashboard React - v1.3.2
=========================================================

* Product Page: https://www.creative-tim.com/product/paper-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

* Licensed under MIT (https://github.com/creativetimofficial/paper-dashboard-react/blob/main/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import PRE_ALERTS from "./views/PRE-ALERTSManagment.js";
import Holidays from "./views/Holidays.js";
import Calendar from "./views/Calendar.js";
import Accounts from "./views/Accounts.js";
import EditProfile from "./views/EditProfile.js";
import ParkingMap from "./views/ParkingMap.js";
import ContainersParking from "./views/ContainersParking.js";
import Parking1 from "./views/Parking1.js";
import Parking2 from "./views/Parking2.js";
import Parking3 from "./views/Parking3.js";
import Parking4 from "./views/Parking4.js";
import Parking5 from "./views/Parking5.js";
import Parking6 from "./views/Parking6.js";
import PorterParkingMap from "./views/PorterParkingMap.js";
import Backup from "./views/Backup.js";
import Reports from "./views/Reports.js";

var routes = [
  {
    path: "/pre-alerts-managment",
    name: "PRE-ALERTS",
    icon: "nc-icon nc-bank",
    element: <PRE_ALERTS/>,
    layout: "/super-admin",
  },
  {
    path: "/accounts",
    name: "ACCOUNTS",
    icon: "nc-icon nc-pin-3",
    element: <Accounts/>,
    layout: "/super-admin",
  },
  {
    path: "/holidays",
    name: "HOLIDAYS & A. SLOTS",
    icon: "nc-icon nc-bell-55",
    element: <Holidays/>,
    layout: "/super-admin",
  },
  {
    path: "/calendar",
    name: "CALENDAR",
    icon: "nc-icon nc-bell-55",
    element: <Calendar/>,
    layout: "/super-admin",
  },
  {
    path: "/edit-profile",
    name: "EDIT PROFILE",
    icon: "nc-icon nc-bell-55",
    element: <EditProfile/>,
    layout: "/super-admin",
  },
  {
    path: "/parking-map",
    name: "PARKING MAP",
    icon: "nc-icon nc-tile-56",
    element: <ParkingMap/>,
    layout: "/super-admin",
  },
  {
    path: "/containers-parking",
    name: "CONTAINERS PARKING",
    icon: "nc-icon nc-tile-56",
    element: <ContainersParking/>,
    layout: "/super-admin",
  },
  {
    path: "/parking-1",
    name: "PARKING #1",
    icon: "nc-icon nc-tile-56",
    element: <Parking1/>,
    layout: "/super-admin",
  },
  {
    path: "/parking-2",
    name: "PARKING #2",
    icon: "nc-icon nc-tile-56",
    element: <Parking2/>,
    layout: "/super-admin",
  },
  {
    path: "/parking-3",
    name: "PARKING #3",
    icon: "nc-icon nc-tile-56",
    element: <Parking3/>,
    layout: "/super-admin",
  },
  {
    path: "/parking-4",
    name: "PARKING #4",
    icon: "nc-icon nc-tile-56",
    element: <Parking4/>,
    layout: "/super-admin",
  },
  {
    path: "/parking-5",
    name: "PARKING #5",
    icon: "nc-icon nc-tile-56",
    element: <Parking5/>,
    layout: "/super-admin",
  },
  {
    path: "/parking-6",
    name: "PARKING #6",
    icon: "nc-icon nc-tile-56",
    element: <Parking6/>,
    layout: "/super-admin",
  },
  {
    path: "/arrivals-and-departures",
    name: "ARRIVALS AND DEPARTURES",
    icon: "nc-icon nc-tile-56",
    element: <PorterParkingMap />,
    layout: "/super-admin",
  },
  {
    path: "/backup",
    name: "BACKUP AND CONDITION",
    icon: "nc-icon nc-diamond",
    element: <Backup/>,
    layout: "/super-admin",
  },
  // {
  //   path: "/reports",
  //   name: "Reports",
  //   icon: "nc-icon nc-diamond",
  //   element: <Reports/>,
  //   layout: "/super-admin",
  // },
];
export default routes;
